export default {
  path: 'participants',
  component: () => import(/* webpackChunkName: "event" */ './wrapper.vue'),
  children: [{
    path: '/',
    component: () => import(/* webpackChunkName: "event" */ './singleWrapper.vue'),
    children: [{
      path: '/',
      name: 'event.discipline.participants',
      component: () => import(/* webpackChunkName: "event" */ './list.vue'),
    },{
      path: 'add',
      name: 'event.discipline.participants.add',
      component: () => import(/* webpackChunkName: "event" */ './add.vue'),
    },{
      path: 'addGroup',
      name: 'event.discipline.participants.addGroup',
      component: () => import(/* webpackChunkName: "event" */ './addGroup.vue'),
    }, {
      path: ':participationId',
      name: 'event.discipline.participants.view',
      component: () => import(/* webpackChunkName: "event" */ './view.vue'),
    }]
  }, {
    path: 'teams',
    component: () => import(/* webpackChunkName: "event" */ './teamWrapper.vue'),
    children: [{
      path: '/',
      name: 'event.discipline.participantsTeam',
      component: () => import(/* webpackChunkName: "event" */ './listTeam.vue'),
    }, {
      path: 'addTeam',
      name: 'event.discipline.participants.addTeam',
      component: () => import(/* webpackChunkName: "event" */ './addTeam.vue'),
    }, {
      path: ':participationId',
      name: 'event.discipline.participants.viewTeam',
      component: () => import(/* webpackChunkName: "event" */ './viewTeam.vue'),
    }]
  }]
}
